import React from 'react'
import Contact from '../public/Contact'
import MenuProvideradmin from './navProvideradmin/MenuProvideradmin'

function ContactExecutive() {
    return (
        <div>
            <MenuProvideradmin menuActive={'contact'}/>
            <Contact disabledMenu/>
        </div>
    )
}

export default ContactExecutive